import { animate, AnimationTriggerMetadata, style, transition, trigger } from '@angular/animations';

const easeInTime = '300ms ease-in';
export const SlideInOutLeftAnimation: AnimationTriggerMetadata = trigger('slideInOutLeft', [
    transition(':enter', [style({ transform: 'translateX(-100%)' }), animate(easeInTime, style({ transform: 'translateX(0%)' }))]),
    transition(':leave', [animate(easeInTime, style({ transform: 'translateX(-100%)' }))])
]);

export const SlideInOutRightAnimation: AnimationTriggerMetadata = trigger('slideInOutRight', [
    transition(':enter', [style({ transform: 'translateX(100%)' }), animate(easeInTime, style({ transform: 'translateX(0%)' }))]),
    transition(':leave', [animate(easeInTime, style({ transform: 'translateX(100%)' }))])
]);

export const RollDownUpAnimation: AnimationTriggerMetadata = trigger('rollDownUp', [
    transition(':enter', [style({ maxHeight: '0', overflow: 'hidden' }), animate(easeInTime, style({ maxHeight: '100dvh' }))]),
    transition(':leave', [style({ overflow: 'hidden', maxHeight: '100dvh' }), animate(easeInTime, style({ maxHeight: '0' }))])
]);
